import React from "react";
import SearchFile from "../components/partials/SearchFile";
import LatestFiles from "../components/partials/LatestFiles";

const FileSearch = ({
  setSearchResults,
  searchLabel,
  lastestButtonsLabel,
  setSearchTerm,
  searchTerm,
  additionalCssClass,
  latestFileTypes,
  onLatestFileButtonClick,
  allowAppRoles,
}) => {
  return (
    <div className={`flex items-center gap-8 ${additionalCssClass}`}>
      <SearchFile
        setSearchResults={setSearchResults}
        label={searchLabel}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        allowAppRoles={allowAppRoles}
      />
      <LatestFiles types={latestFileTypes} onButtonClick={onLatestFileButtonClick} label={lastestButtonsLabel} allowAppRoles={allowAppRoles} />
    </div>
  );
};

export default FileSearch;
